import React, { useCallback, useEffect, useState } from 'react';
import { Button, CheckboxListCard, CheckboxListItem, Stack, VStack, } from '@adc/parallax-component-library';
import { Footer, Form, Header, LogoActionBar, Main, RichText, ScrollContainer, } from 'Components/utility';
import { SHOW_MODAL } from 'Reducers/modal/types';
import { REGISTER } from 'Reducers/register/types';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';
const RegisterLegalNotices = ({ next, back, values, currentStep }) => {
    const [termsOfUseChecked, setTermsOfUseChecked] = useState(false);
    const [privacyNoticeChecked, setPrivacyNoticeChecked] = useState(false);
    useEffect(() => {
        const touLibre = values.consents.find((consent) => consent.id === 'touLibre');
        const pp = values.consents.find((consent) => consent.id === 'pp');
        setTermsOfUseChecked(touLibre?.action === 'accept');
        setPrivacyNoticeChecked(pp?.action === 'accept');
    }, [values]);
    const handleLinkClick = (href) => {
        store.dispatch({
            type: REGISTER,
            register: {
                ...values,
                currentStep,
                consents: [
                    {
                        id: 'touLibre',
                        action: termsOfUseChecked ? 'accept' : 'decline',
                    },
                    {
                        id: 'pp',
                        action: privacyNoticeChecked ? 'accept' : 'decline',
                    },
                ],
            },
        });
        mediator.publish('router:navigate', href);
    };
    const showAcceptTermsError = useCallback(() => {
        store.dispatch({
            type: SHOW_MODAL,
            modalProps: {
                details: i18n.t('LegalNotices.modals.tapCheckbox.body'),
                testID: 'LegalNotices.modals.tapCheckbox.body',
            },
        });
    }, []);
    const onSubmit = useCallback((declined) => {
        if (!termsOfUseChecked || !privacyNoticeChecked || declined) {
            showAcceptTermsError();
            return;
        }
        const register = {
            ...values,
            consents: [
                {
                    id: 'touLibre',
                    action: 'accept',
                },
                {
                    id: 'pp',
                    action: 'accept',
                },
            ],
        };
        next(register);
    }, [next, privacyNoticeChecked, showAcceptTermsError, termsOfUseChecked, values]);
    return (React.createElement(Main, null,
        React.createElement(LogoActionBar, { actionButtonTestID: "RegisterLegalNotices.action-go-back", titleTestID: "RegisterLegalNotices.actionTitle", title: i18n.t('LegalNotices.title'), onBack: back }),
        React.createElement(ScrollContainer, null,
            React.createElement(Header, { titleTestID: "RegisterLegalNotices.title", title: i18n.t('LegalNotices.title') }),
            React.createElement(Form, null,
                React.createElement(Stack, { gap: "$4" },
                    React.createElement(RichText, { onPressLink: handleLinkClick, testID: "RegisterLegalNotices.bodyText", text: i18n.t('LegalNotices.content.legalNoticeCopy.bodyText') }),
                    React.createElement(CheckboxListCard, null,
                        React.createElement(CheckboxListItem, { checked: termsOfUseChecked, onPress: () => setTermsOfUseChecked(!termsOfUseChecked), testID: "RegisterLegalNotices.acceptTermsOfUse", title: i18n.t('LegalNotices.content.acceptTermsOfUse.primaryText'), details: i18n.t('LegalNotices.content.acceptTermsOfUse.secondaryText') })),
                    React.createElement(CheckboxListCard, null,
                        React.createElement(CheckboxListItem, { checked: privacyNoticeChecked, onPress: () => setPrivacyNoticeChecked(!privacyNoticeChecked), testID: "RegisterLegalNotices.acceptPrivacyNotice", title: i18n.t('LegalNotices.content.acceptPrivacyNotice.primaryText'), details: i18n.t('LegalNotices.content.acceptPrivacyNotice.secondaryText') }))))),
        React.createElement(Footer, { customProps: React.createElement(VStack, { padding: "$4" },
                React.createElement(Button, { onPress: () => onSubmit(), testID: "RegisterLegalNotices.accept-btn", label: i18n.t('Global.microcopy.common.accept'), "aria-label": i18n.t('Global.microcopy.common.accept'), marginBottom: "$4" }),
                React.createElement(Button, { variant: "tertiary", testID: "RegisterLegalNotices.decline-btn", label: i18n.t('Global.microcopy.common.decline'), "aria-label": i18n.t('Global.microcopy.common.decline'), onPress: () => onSubmit(true) })) })));
};
export default RegisterLegalNotices;
